import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  Stack,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Box,
} from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import SyncIcon from "@mui/icons-material/Sync";
import CustomTypography from "../../globalStyles/fonts";
import DeleteConfirmationModal from "../deleteConfirmationModal";

const WebhookModal = ({
  openWebhook,
  setOpenWebhook,
  newWebhook,
  setNewWebhook,
  selectedWebhook,
  submit,
  webhooks,
  handleEdit,
  handleCancel,
  confirmDelete,
  openConfirmation,
  setOpenConfirmation,
  providerData,
  selectedWebhookData,
  onRegisterWebhooks,
  registeringWebhooks,
}) => {
  const [metafieldInputs, setMetafieldInputs] = useState({});
  const [webhookToDelete, setWebhookToDelete] = useState(null);

  return (
    <Dialog
      open={openWebhook !== null} // Open when a webhook is clicked
      onClose={() => setOpenWebhook(null)} // Close dialog on Cancel
      fullWidth
      maxWidth="md" // Adjust width if needed
    >
      <DialogTitle>Manage Webhook</DialogTitle>

      <DialogContent
        sx={{
          "&::-webkit-scrollbar": {
            display: "none", // For WebKit browsers (Chrome, Safari)
          },
          "-ms-overflow-style": "none", // For Internet Explorer and Edge
          "scrollbar-width": "none", // For Firefox
          overflowY: "auto",
        }}
        dividers
      >
        {openWebhook !== null && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginBottom: 20,
              //   borderBottom: '0.5px solid #737791',
              padding: 10,
            }}
          >
            <div style={{ width: "100%" }}>
              {newWebhook?.map((x, index) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    // width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 2,
                    border: "1px solid var(--border-color)",
                    padding: 2,
                    position: "relative",
                  }}
                >
                  {newWebhook.length > 1 && (
                    <IconButton
                      style={{
                        color: "#D13438",
                        padding: 0,
                        background: "#D1343833",
                        height: "30px",
                        width: "30px",
                        borderRadius: "5px",
                        boxShadow: "0px 0px 4px 0px #00000040",
                        position: "absolute",
                        top: 8,
                        right: 8,
                      }}
                      aria-label="delete"
                      onClick={() =>
                        setNewWebhook({
                          type: "REMOVE_WEBHOOK",
                          index: index,
                        })
                      }
                    >
                      <img
                        style={{ height: "15px", width: "15px" }}
                        alt="delete"
                        src="/delete.png"
                      />
                    </IconButton>
                  )}
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    sx={{ maxWidth: { xs: "100%", md: "100%" } }}
                  >
                    <Grid item xs={12} md={6}>
                      <CustomTypography fontSize={13}>Type</CustomTypography>
                      <TextField
                        size="small"
                        value={x.topic}
                        onChange={(e) =>
                          setNewWebhook({
                            type: "WEBHOOK_CHANGE",
                            index: index,
                            value: { topic: e.target.value },
                          })
                        }
                        placeholder="Topic"
                        fullWidth
                        margin="dense"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CustomTypography fontSize={13}>URL</CustomTypography>
                      <TextField
                        size="small"
                        value={x.address}
                        onChange={(e) =>
                          setNewWebhook({
                            type: "WEBHOOK_CHANGE",
                            index: index,
                            value: { address: e.target.value },
                          })
                        }
                        placeholder="Address"
                        fullWidth
                        margin="dense"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <CustomTypography fontSize={13}>
                        Metafields
                      </CustomTypography>
                      <TextField
                        size="small"
                        value={metafieldInputs[index] || ""}
                        onChange={(e) =>
                          setMetafieldInputs((prev) => ({
                            ...prev,
                            [index]: e.target.value,
                          }))
                        }
                        onKeyDown={(e) => {
                          if (
                            e.key === "Enter" &&
                            metafieldInputs[index]?.trim()
                          ) {
                            e.preventDefault();
                            const val = metafieldInputs[index].trim();
                            if (!(x.metafield_namespaces || []).includes(val)) {
                              setNewWebhook({
                                type: "WEBHOOK_CHANGE",
                                index: index,
                                value: {
                                  metafield_namespaces: [
                                    ...(x.metafield_namespaces || []),
                                    val,
                                  ],
                                },
                              });
                            }
                            setMetafieldInputs((prev) => ({
                              ...prev,
                              [index]: "",
                            }));
                          }
                        }}
                        placeholder="Type and press Enter to add"
                        fullWidth
                        margin="dense"
                      />
                      {(x.metafield_namespaces || []).length > 0 && (
                        <Stack direction="row" flexWrap="wrap" gap={1} mt={1}>
                          {(x.metafield_namespaces || []).map((ns, nsIndex) => (
                            <Chip
                              key={nsIndex}
                              label={ns}
                              size="small"
                              onDelete={() =>
                                setNewWebhook({
                                  type: "WEBHOOK_CHANGE",
                                  index: index,
                                  value: {
                                    metafield_namespaces: (
                                      x.metafield_namespaces || []
                                    ).filter((_, i) => i !== nsIndex),
                                  },
                                })
                              }
                            />
                          ))}
                        </Stack>
                      )}
                    </Grid>
                    {/* <Grid>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          height: "100%",
                          marginTop: 22,
                          marginLeft: 20,
                        }}
                      >
                        {newWebhook.length === 1 &&
                          !(selectedWebhook?.id || selectedWebhook?._id) && (
                            <Button
                              onClick={() =>
                                submit(providerData[openWebhook]?._id)
                              }
                              sx={{ marginLeft: 1, textTransform: "none" }}
                              variant="contained"
                            >
                              Submit
                            </Button>
                          )}
                      </div>
                    </Grid> */}
                  </Grid>
                </Box>
              ))}
              <div
                style={{
                  marginTop: 20,
                  justifyContent: "flex-end",
                  display: "flex",
                  width: "100%",
                }}
              >
                <Button
                  onClick={() => submit(providerData[openWebhook]?._id)}
                  sx={{ marginRight: 1, textTransform: "none" }}
                  variant="contained"
                >
                  Submit
                </Button>
                <Button
                  onClick={handleCancel}
                  sx={{ textTransform: "none", marginRight: 1 }}
                  variant="outlined"
                >
                  Cancel
                </Button>
              </div>
            </div>
            <div>
              {!(selectedWebhook?.id || selectedWebhook?._id) && (
                <div
                  style={{
                    width: "50%",
                    //  padding: 10,
                    cursor: "pointer",
                    marginBottom: 10,
                  }}
                  onClick={() => setNewWebhook({ type: "ADD_WEBHOOK" })}
                >
                  <CustomTypography
                    fontSize={13}
                    style={{ color: "#007BFF", marginLeft: 1 }}
                  >
                    + Add More
                  </CustomTypography>
                </div>
              )}
            </div>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <CustomTypography
                fontSize={13}
                style={{ fontWeight: "600", marginLeft: 1 }}
              >
                Webhook List
              </CustomTypography>
              <Button
                size="small"
                startIcon={<SyncIcon />}
                disabled={registeringWebhooks}
                onClick={() => onRegisterWebhooks(selectedWebhookData?._id)}
                sx={{ textTransform: "none" }}
                variant="outlined"
              >
                Register Webhooks
              </Button>
            </Box>

            <TableContainer
              sx={{
                minHeight: "200px",
                overflow: "auto",
                mt: 1,
                maxHeight: 400,
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ background: "#EEEEEEEE" }}>
                      <CustomTypography fontWeight={600} fontSize={13}>
                        Type
                      </CustomTypography>
                    </TableCell>
                    <TableCell sx={{ background: "#EEEEEEEE" }}>
                      <CustomTypography fontWeight={600} fontSize={13}>
                        URL
                      </CustomTypography>
                    </TableCell>
                    <TableCell sx={{ background: "#EEEEEEEE" }}>
                      <CustomTypography fontWeight={600} fontSize={13}>
                        Metafields
                      </CustomTypography>
                    </TableCell>
                    <TableCell sx={{ background: "#EEEEEEEE" }}>
                      <CustomTypography fontWeight={600} fontSize={13}>
                        Action
                      </CustomTypography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {webhooks?.map((webhook, index) => (
                    <TableRow sx={{ maxHeight: 200 }} key={index}>
                      <TableCell sx={{ borderBottom: 0 }}>
                        <CustomTypography fontSize={13}>
                          {webhook.topic}
                        </CustomTypography>
                      </TableCell>
                      <TableCell sx={{ borderBottom: 0 }}>
                        <CustomTypography fontSize={13}>
                          {webhook.address?.split("?")[0]}
                        </CustomTypography>
                      </TableCell>
                      <TableCell sx={{ borderBottom: 0 }}>
                        <Stack direction="row" flexWrap="wrap" gap={1}>
                          {(webhook.metafield_namespaces || []).map(
                            (ns, nsIndex) => (
                              <Chip
                                key={nsIndex}
                                label={ns}
                                size="small"
                                sx={{ fontSize: 12 }}
                              />
                            ),
                          )}
                        </Stack>
                      </TableCell>
                      <TableCell sx={{ borderBottom: 0 }}>
                        <IconButton
                          style={{
                            color: "#FEC50F",
                            padding: 0,
                            background: "#FEC50F33",
                            height: 30,
                            width: 30,
                            borderRadius: 5,
                            boxShadow: "0px 0px 4px 0px #00000040",
                            marginTop: 5,
                          }}
                          aria-label="edit"
                          onClick={() => handleEdit(webhook)}
                        >
                          <BorderColorIcon sx={{ height: 20, width: 20 }} />
                        </IconButton>
                        <IconButton
                          style={{
                            color: "#D13438",
                            padding: 0,
                            background: "#D1343833",
                            height: 30,
                            width: 30,
                            borderRadius: 5,
                            marginLeft: 15,
                            boxShadow: "0px 0px 4px 0px #00000040",
                            marginTop: 5,
                          }}
                          aria-label="delete"
                          onClick={() => {
                            setWebhookToDelete(webhook);
                            setOpenConfirmation(true);
                          }}
                        >
                          <img
                            style={{ height: 15, width: 15 }}
                            alt="delete"
                            src="/delete.png"
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

        <DeleteConfirmationModal
          title={`Are you sure you want to delete this Webhook?`}
          open={openConfirmation}
          handleClose={() => {
            setOpenConfirmation(false);
            setWebhookToDelete(null);
          }}
          handleDelete={() =>
            confirmDelete(webhookToDelete, selectedWebhookData.shop_name)
          }
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenWebhook(null)} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WebhookModal;
